<template>
  <div class="calendar-online">
    <div class="type-calendar h-48"><h2>会議の開催</h2></div>

    <SelectCategory v-show="currentStep === 'select-category'"
                    v-model="meetingData.category"/>

    <SetTitle v-show="currentStep === 'set-title'"
              v-model="meetingData.title"/>

    <SelectUsers v-show="currentStep === 'add-users'"
                 v-model="meetingData.selectedUsers"
                 @changeStep="changeStep"/>

    <ConfirmUsers v-show="currentStep === 'confirm-users'"
                  v-model="meetingData.selectedUsers"
                  @changeStep="changeStep"/>

    <TimePicker v-if="currentStep === 'time-picker'"
                v-model="meetingData.time"
                @changeStep="changeStep"/>

    <Confirm v-if="currentStep === 'confirm'" :meeting="meetingData"/>

    <LastStep v-if="currentStep === 'last-step'"
    :meeting="meeting" />

    <Buttons :current-step="currentStep"
             :steps="steps"
             :disable-next-step="disableNextStep"
             :meeting-category="meetingData.category"
             @changeStep="changeStep"/>
  </div>
</template>

<script>
import MeetingsApi from '@/api/meeting'
import Calendar from '@/components/Calendar'
import SelectCategory from '@/components/meetings/create/SelectCategory'
import SetTitle from '@/components/meetings/create/SetTitle'
import SelectUsers from '@/components/meetings/create/SelectUsers'
import ConfirmUsers from '@/components/meetings/create/ConfirmUsers'
import TimePicker from '@/components/meetings/create/TimePicker'
import Confirm from '@/components/meetings/create-online/Confirm'
import LastStep from '@/components/meetings/create-online/LastStep'
import Buttons from '@/components/meetings/create/Buttons'
import UserApi from '@/api/users'
import {USER_TYPE_PHARMACIST} from '@/const'
import {apiErrorDialog} from '@/helpers'

export default {
  components: {
    Calendar,
    SelectCategory,
    SelectUsers,
    ConfirmUsers,
    TimePicker,
    Confirm,
    LastStep,
    Buttons,
    SetTitle
  },
  data () {
    return {
      currentStep: 'select-category',
      steps: ['select-category', 'set-title', 'add-users', 'confirm-users', 'time-picker', 'confirm', 'last-step'],
      meetingData: {category: 2, title: '', selectedUsers: [], time: {start: null, end: null, dayInWeek: null}},
      disableNextStep: true,
      meeting: {}
    }
  },
  methods: {
    showErrorMessage (msg) {
      this.$message.error(msg)
    },
    async changeStep (step, back = false) {
      if (!back) {
        if (this.currentStep === 'select-category') {
          if (!this.meetingData.category) {
            this.showErrorMessage('カテゴリーを選んでください !')
            return false
          }
        } else if (this.currentStep === 'add-pharmacies') {
          if (!this.meetingData.pharmacy) {
            this.showErrorMessage('薬局を選んでください !')
            return false
          }
        } else if (this.currentStep === 'time-picker') {
          if (!this.meetingData.time.start || !this.meetingData.time.end) {
            this.showErrorMessage('会議の日付を選んでください !')
            return false
          }
        } else if (this.currentStep === 'confirm') {
          await this.createMeeting()
        } else if (this.currentStep === 'last-step') {
          return this.$router.push({name: 'home'})
        }
      }
      this.currentStep = step
    },
    async createMeeting () {
      const loading = this.$loading.show()

      try {
        let meeting = {}
        meeting.title = this.meetingData.title
        meeting.category_id = this.meetingData.category
        meeting.user_ids = this.meetingData.selectedUsers.map(n => n.id)
        meeting.start_at = this.meetingData.time.start.format('Y-MM-DD HH:mm:00')
        meeting.end_at = this.meetingData.time.end.format('Y-MM-DD HH:mm:00')
        let res = await MeetingsApi.store(meeting)
          .catch((error) => {
            loading.hide()
            apiErrorDialog(this, error)
          })
        this.meeting = res.data.data
      } catch (e) {
        console.log(e)
      }

      loading.hide()
    },
    async fetchUsers () {
      const loading = this.$loading.show()
      const res = await UserApi.get({type: 0, from_pp: true})
        .catch((error) => {
          loading.hide()
          apiErrorDialog(this, error)
        })
      if (res.data.data.length > 0 || this.$auth.user().type === USER_TYPE_PHARMACIST) {
        this.disableNextStep = false
      }
      loading.hide()
    }
  },
  mounted () {
    this.fetchUsers()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Meeting/CreateOnline.vue